import styled from 'styled-components';
import { Box } from '@chargify/custom-ui-components';

export const FilterBoxList = styled(Box)`
  background-color: ${({ theme }) => theme.colors.primary.extraLight};
  justify-content: left;
  border-radius: ${({ theme }) => theme.radii[3]}px;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[3]}px;
`;

FilterBoxList.defaultProps = {
  padding: 4,
  display: 'flex',
};
